<template>
  <modal
    class="editPumpStat"
    name="accountCompanySettlement"
    transition="pop-out"
    :width="600"
    :height="600"
  >
    <div class="modal__header">
      <span class="mr-3"
        ><img src="@/assets/img/building (1).svg" width="30" height="30"
      /></span>
      <h4>{{ $t("text.cBank.confirmSettlement") }}</h4>
    </div>
    <div>
      <div class="input__group__block mt-4" style="margin: 0 auto; width: 70%">
        <label class="required">
          {{ $t("text.cBank.date") }}
        </label>
        <div class="input__block" ref="target_input_div">
          <vue-ctk-date-time-picker
            id="DateTimePicker"
            v-model="date"
            color="#290C53"
            format="YYYY-MM-DDTHH:mm:ss.sssZ"
            formatted="DD/MM/YYYY h:mm a"
            label="Select date and time"
          />
        </div>
      </div>

      <div class="input__group__block mt-4" style="margin: 0 auto; width: 70%">
        <label class="required">
          {{ $t("text.cBank.amountToSettle") }}
        </label>
        <div class="input__block" ref="target_input_div">
          <input
            style="padding: 10px; width: 100%"
            type="number"
            v-model="amount"
          />
        </div>
      </div>

      <div class="text-center py-3 mt-3">
        <button
          @click="settleCompany"
          class="sales_target_btn text-center"
          :disabled="isButtonDisabled ? true : null"
          :style="[
            isButtonDisabled
              ? { cursor: 'not-allowed' }
              : { cursor: 'pointer' },
          ]"
        >
          {{ $t("text.cBank.confirm") }}<span></span>
        </button>
        <img
          v-show="showSpinner"
          src="@/assets/img/git_loader.gif"
          width="35px"
          class="ml-3 loader"
        />
      </div>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 850;
import configObject from "@/config";

export default {
  name: "accountsCompanySettlements",
  props: ["selectedCompanyId", "callAllFunctions"],
  data() {
    return {
      date: "",
      amount: null,
      transactionType: null,
      close: false,
      isButtonDisabled: false,
      showSpinner: false,
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    toggleIsClosed() {
      this.close = !this.close;
    },
    settleCompany() {
      if (!this.date) {
        this.$toast.open({
          message: this.$t("text.errors.selectDate"),
          type: "error",
          duration: 10000,
        });
        return;
      }

      if (!this.amount) {
        this.$toast.open({
          message: this.$t("text.errors.amountError"),
          type: "error",
          duration: 10000,
        });

        return;
      }

      const data = {
        amount: parseFloat(this.amount),
        type: "credit",
        date: this.date,
      };

      $(".loader").show();
      this.isButtonDisabled = true;

      this.axios
        .post(
          `${configObject.apiBaseUrl}/Company/PostSettlement/${this.selectedCompanyId}`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.$toast.open(this.$t("text.cBank.paymentConfirmed"), {
            type: "success",
            timeout: 3000,
          });
          this.callAllFunctions()
          this.isButtonDisabled = false;
          this.amount = null;
          this.transactionType = null;
          this.date = null;
          $(".loader").hide();
          this.$modal.hide("accountCompanySettlement");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast(error.response.data.message, {
            type: "error",
            timeout: 3000,
          });
        });
    },
  },
};
</script>
